import { render, staticRenderFns } from "./media-kits.vue?vue&type=template&id=abb3c376&scoped=true"
import script from "./media-kits.vue?vue&type=script&lang=js"
export * from "./media-kits.vue?vue&type=script&lang=js"
import style0 from "./media-kits.vue?vue&type=style&index=0&id=abb3c376&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abb3c376",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SubNav: require('/app/components/SubNav.vue').default,Sticky: require('/app/components/Sticky.vue').default,SvgDownload: require('/app/components/svg/Download.vue').default,Anchor: require('/app/components/Anchor.vue').default})
